import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImporterComponent } from './importer.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [ImporterComponent],
  exports:[ImporterComponent],
  imports: [
    CommonModule,FormsModule
  ]
})
export class ImporterModule { }
